<template>

    <!-- 变更等级统计 -->
    <div>
        <el-col :span="16">
            <div ref="changeLevelChart" :style="astyle">
            </div>
        </el-col>
        <el-col :span="8">
            <p class="bold">数据中心等级变更对比</p>
            <p>一级变更总数：<span class="orange-font bold">{{level1Total}}</span></p>
            <p>二级变更总数：<span class="orange-font bold">{{level2Total}}</span></p>
            <p>三级变更总数：<span class="orange-font bold">{{level3Total}}</span></p>
            <p>四级变更总数：<span class="orange-font bold">{{level4Total}}</span></p>
        </el-col>
    </div>

</template>

<script>
    import {formatDate, parseDate} from "element-ui/src/utils/date-util";
    import echarts from "echarts";
    import WorkOrderServer from "@/api/workorder";

    let that;

    export default {
        name: "changeLevelNumStatistics",

        props: {
            astyle: {
                type: String,
            },
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        data() {
            return {
                level1Total: 0,
                level2Total: 0,
                level3Total: 0,
                level4Total: 0,
            }
        },

        methods: {
            query() {
                let params = {
                    'dcnums': this.dcnumids,
                    'date': this.searchDate,
                    'type': 'change',
                }
                WorkOrderServer.workOrder.levelStatistics(params).then(res => {
                    this.level1Total = 0;
                    this.level2Total = 0;
                    this.level3Total = 0;
                    for (let i = 0; i < res.length; i++) {
                        if (res[i].level == 'LEVEL1') {
                            this.level1Total = res[i].finishCount;
                            continue;
                        } else if (res[i].level == 'LEVEL2') {
                            this.level2Total = res[i].finishCount;
                            continue;
                        } else if (res[i].level == 'LEVEL3') {
                            this.level3Total = res[i].finishCount;
                            continue;
                        } else if (res[i].level == 'LEVEL4') {
                            this.level4Total = res[i].finishCount;
                            continue;
                        }
                    }
                    this.renderLevelNumChart(this.level1Total, this.level2Total, this.level3Total, this.level4Total);
                });
            },

            getFirstDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                return new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0, 0);
            },

            getLastDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                let firstDateInNextMonth = new Date(current.getFullYear(), current.getMonth() + 1, 1, 0, 0, 0, 0);
                return new Date(firstDateInNextMonth.getTime() - 1);
            },

            renderLevelNumChart(level1Total, level2Total, level3Total, level4Total) {
                let myChart = echarts.init(this.$refs.changeLevelChart);
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: ['一级变更', '二级变更', '三级变更', '四级变更']
                    },
                    series: [
                        {
                            name: '数据中心等级变更对比',
                            type: 'pie',
                            radius: ['40%', '50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: 'left'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '20',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data: [
                                {value: level1Total, name: '一级变更'},
                                {value: level2Total, name: '二级变更'},
                                {value: level3Total, name: '三级变更'},
                                {value: level4Total, name: '四级变更'},
                            ]

                        }
                    ]
                };
                myChart.setOption(option);
            },
        },

        watch: {
            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.length > 0) {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },
        },

        created() {
            that = this;
        },
    }
</script>

<style scoped>

</style>
